import React from "react";
import { Box } from "@mui/material";
import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import DotLegalTextFieldWithSnippets from "@common/components/dotLegalTextFieldWithSnippets/DotLegalTextFieldWithSnippets.tsx";

export interface IncidentLogTextWithSuggestionsFieldProps {
    label: string;
    placeholder: string;
    suggestionsHeader: string;
    suggestions: Array<string>;
    isPreview: boolean;
    value?: string;
    onChange: (value: string) => void;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogTextWithSuggestionsField(props: IncidentLogTextWithSuggestionsFieldProps) {
    return (
        <Box sx={{ mb: 3 }}>
            <DotLegalHeader marginBottom={1} headerStyle={"small"}>
                {props.label}
            </DotLegalHeader>
            <DotLegalTextFieldWithSnippets
                // The template editor preview shows no suggestions, as there is nothing to insert them into.
                snippets={props.isPreview ? [] : props.suggestions}
                select={props.suggestionsHeader}
                value={props.value ?? ""}
                onChange={props.onChange}
                label={""}
                placeholder={props.placeholder}
                variant={"outlined"}
                error={""}
                errorText={props.errorText}
                rows={5}
                debounce
                disabled={props.disabled}
                disableValidation
                noMargin
                limitHeight
                hideFrame
            />
        </Box>
    );
}

export default IncidentLogTextWithSuggestionsField;
